import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from "@angular/core";
import {
  BvAlign,
  BvJustify,
  BvSpace,
  alignToCss,
  justifyToCss,
  spaceVar,
} from "./types";

@Component({
    selector: "bv-cluster",
    template: "<ng-content></ng-content>",
    styles: [
        `
      :host {
        display: flex;
        flex-direction: row;
        min-width: 0;
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BvClusterComponent {
  @Input() gap: BvSpace = "0";
  @Input() align?: BvAlign;
  @Input() justify?: BvJustify;
  @Input() wrap = false;

  @HostBinding("style.gap")
  get gapStyle(): string {
    return spaceVar(this.gap);
  }

  @HostBinding("style.align-items")
  get alignStyle(): string | null {
    return this.align ? alignToCss(this.align) : null;
  }

  @HostBinding("style.justify-content")
  get justifyStyle(): string | null {
    return this.justify ? justifyToCss(this.justify) : null;
  }

  @HostBinding("style.flex-wrap")
  get wrapStyle(): string {
    return this.wrap ? "wrap" : "nowrap";
  }
}
